import React, { Component } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core'
import { connect } from 'react-redux'
import {
  adoptOrphanCategories,
  adoptOrphanProducts,
  getListCategories,
} from '../../../actions/masterCatalog'
import { openErrorMessage } from '../../../actions/message'

class ModalReviewDataAdoptionMode extends Component {
  constructor(props) {
    super(props)
  }

  handleUpdateProducts = () => {
    const { selectedParentCategory } = this.props
    const items =
      (this.props.isProduct ? this.props.selectedProducts : this.props.selectedCategories) || []
    const itemsIds = items.map((item) => item.id)
    const firstItem = this.props.selectedParent

    const shopIds = []
    var shopRepeat = false

    items.map((item) => {
      if (!shopIds.includes(item.shopId)) {
        shopIds.push(item.shopId)
      } else {
        shopRepeat = true
      }
    })

    if (shopRepeat) {
      return this.props.dispatch(
        openErrorMessage(
          `You cannot select more than 1 ${
            this.props.isProduct ? 'product' : 'category'
          } from the same store `,
        ),
      )
    }

    var adoptionMode = JSON.parse(localStorage.getItem('ADOPTION_MODE'))

    const body = {
      orphanIds: itemsIds,
      adoptionMode: adoptionMode,
      masterCategory: selectedParentCategory,
    }

    if (this.props.isProduct) {
      firstItem && (body.parentProductId = firstItem.id)

      this.props.dispatch(adoptOrphanProducts(body)).then(() => {
        this.props.close && this.props.close(true)
        this.props.dispatch(getListCategories())
      })
    } else {
      body.orphanCategory = firstItem

      this.props.dispatch(adoptOrphanCategories(body)).then(() => {
        this.props.close && this.props.close(true)
      })
    }
  }

  render() {
    const {
      open,
      close,
      selectedProducts = [],
      selectedCategories = [],
      isProduct,
      selectedParent,
      selectedParentCategory,
    } = this.props
    const items = isProduct ? selectedProducts : selectedCategories
    var adoptionMode = JSON.parse(localStorage.getItem('ADOPTION_MODE'))

    return (
      <Dialog open={open} className={'container-small-modal'}>
        <DialogTitle>Adoption Mode - Confirmation</DialogTitle>
        <DialogContent className={'size-small-modal'}>
          {adoptionMode === 'alwaysUpdateChild' ? (
            <div className={'text-confirmation-adoption-mode'}>
              <span
                className={'text-description-adoption-mode'}
                style={{ fontWeight: 'bold', fontSize: '15px' }}
              >
                Always update child
              </span>
              <br />
              <span className={'text-description-adoption-mode'}>
                The{' '}
                {!selectedParent && isProduct
                  ? 'first orphan product '
                  : !selectedParentCategory && !isProduct
                  ? 'first orphan category '
                  : ''}{' '}
                {isProduct && selectedParent
                  ? 'master product '
                  : !isProduct && selectedParentCategory
                  ? 'master category '
                  : ''}
                <b>
                  {isProduct
                    ? selectedParent
                      ? selectedParent.name + ' '
                      : ''
                    : selectedParentCategory
                    ? selectedParentCategory.name + ' '
                    : ''}
                  {isProduct && !selectedParent
                    ? items[0].name + ' '
                    : !isProduct && !selectedParentCategory
                    ? items[0].name + ' '
                    : ''}
                </b>
                selected during adoption mode acts as the parent.
              </span>
              <span className={'text-description-adoption-mode'}>
                {`The children ${isProduct ? 'products' : 'categories'}`}{' '}
                <b>will take all the values</b> of the master{' '}
                {`${isProduct ? 'product' : 'category'} selected.`}
              </span>
            </div>
          ) : (
            <div className={'text-confirmation-adoption-mode'}>
              <span
                className={'text-description-adoption-mode'}
                style={{ fontWeight: 'bold', fontSize: '15px' }}
              >
                Always Create Overrides - Do not update the child with parent values
              </span>
              <br />
              <span className={'text-description-adoption-mode'}>
                The{' '}
                {!selectedParent && isProduct
                  ? 'first orphan product '
                  : !selectedParentCategory && !isProduct
                  ? 'first orphan category '
                  : ''}{' '}
                {isProduct && selectedParent
                  ? 'master product '
                  : !isProduct && selectedParentCategory
                  ? 'master category '
                  : ''}
                <b>
                  {isProduct
                    ? selectedParent
                      ? selectedParent.name + ' '
                      : ''
                    : selectedParentCategory
                    ? selectedParentCategory.name + ' '
                    : ''}
                  {isProduct && !selectedParent
                    ? items[0].name + ' '
                    : !isProduct && !selectedParentCategory
                    ? items[0].name + ' '
                    : ''}
                </b>
                selected during adoption mode acts as the parent.
              </span>
              <span className={'text-description-adoption-mode'}>
                {`The children ${isProduct ? 'products' : 'categories'}`}{' '}
                <b>will only take the name</b> of the master{' '}
                {`${isProduct ? 'product' : 'category'} selected.`}
              </span>
            </div>
          )}
          <br />
          <span className={'text-description-adoption-mode'}>
            These changes cannot be undone. Please confirm the action to proceed.
          </span>
          <br />
          <div className={'container-review-adoption'}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Shop</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {items.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{item.name}</TableCell>
                    {item.shop && item.shop.name ? (
                      <TableCell style={{ fontWeight: 'bold' }}>{item.shop.name}</TableCell>
                    ) : (
                      <TableCell></TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </DialogContent>
        <DialogActions className="container-buttons-adoption-mode">
          <Button
            onClick={() => {
              close && close(false)
            }}
            className="button-white-and-red"
          >
            <span className="button-text">Cancel</span>
          </Button>
          <Button onClick={this.handleUpdateProducts} className="button-blue-and-white">
            <span className="button-text">Continue</span>
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default ModalReviewDataAdoptionMode

export const ModalReviewDataAdoptionModeConnect = connect(({ dispatch }) => ({
  dispatch,
}))(ModalReviewDataAdoptionMode)



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/Fields/ModalReviewDataAdoptionMode.js